/*!
 *
 *	menu.js
 *
 */

$.fn.menu = function(){
	$(this).on('tap', function(e){
		e.preventDefault();
		var _target = $(this).attr('href');
		$(this).toggleClass('active');
		$(_target).stop(false, true).toggleClass('active');
		// $(_target).stop(false, true).toggleClass('active').animate({
		// 	height: 'toggle'
		// }, 700, 'easeOutExpo');
	});
};


//////////////////
// WEBPACK FOOTER
// ./dev/js/module/menu.js
// module id = 16
// module chunks = 0